export const rivetDelimiter = '\\\\';
export const rivetDelimiterAlternate = '||||';
